export const filterCategory = state => state.initData.categories;